var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPt = function SvgPt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2.662.004h19.214v31.992H-2.662V.004z",
    fill: "#090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.51 0h28.823v32H16.51V0z",
    fill: "#F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.478 12.117l-.06 1.192 8.017-.794.06-1.192-8.017.793z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.55 12.248l-.045.913 7.86-.776.044-.913-7.86.778z",
    fill: "#EFEF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.437 11.87l-.02.39 8.098-.8.02-.39-8.098.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.502 12.003l-.005.11 7.953-.786.006-.11-7.953.786z",
    fill: "#EFEF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.372 13.174l-.02.39 8.098-.8.02-.39-8.098.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.437 13.307l-.005.11 7.953-.786.006-.11-7.952.787z",
    fill: "#EFEF00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.69 15.925l-.06 1.192 8.017-.793.06-1.192-8.017.793z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.76 16.056l-.044.913 7.86-.778.044-.913-7.86.776z",
    fill: "#EFEF00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.648 15.678l-.02.39 8.098-.8.02-.39-8.098.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.713 15.81l-.006.112 7.953-.787.006-.11-7.953.786z",
    fill: "#EFEF00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.584 16.982l-.02.39 8.098-.8.02-.39-8.098.8z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 17.115l-.007.11 7.953-.786.006-.112-7.953.787z",
    fill: "#EFEF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.205 20.216l-.06 1.192 8.017-.793.06-1.192-8.017.793z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.276 20.347l-.045.913 7.86-.777.045-.913-7.86.777z",
    fill: "#EFEF00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.164 19.97l-.02.39 8.098-.8.02-.392-8.098.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.228 20.102l-.006.11 7.953-.786.006-.11-7.952.786z",
    fill: "#EFEF00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 21.274l-.02.39 8.097-.8.02-.39-8.098.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.164 21.407l-.006.11 7.953-.786.007-.11-7.953.787z",
    fill: "#EFEF00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.17 19.914l.058 1.192-8.016-.793-.06-1.192 8.017.794z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.097 20.045l.045.913-7.86-.777-.044-.912 7.86.777z",
    fill: "#EFEF00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.21 19.667l.02.39-8.098-.8-.02-.39 8.098.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.145 19.8l.006.11-7.952-.786-.005-.11 7.953.786z",
    fill: "#EFEF00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.275 20.97l.02.392-8.098-.8-.02-.392 8.098.8z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M17.21 21.105l.006.11-7.953-.786-.005-.112 7.953.787z",
    fill: "#EFEF00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16.61 16.464l-.354 1.075-8.547-.91.352-1.076 8.547.91z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.484 16.58l-.27.823-8.38-.892.27-.822 8.38.892z",
    fill: "#EFEF00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.74 16.242l-.115.353-8.634-.92.117-.352 8.634.92z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.623 16.36l-.033.1-8.48-.9.033-.1 8.48.9z",
    fill: "#EFEF00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.355 17.42l-.116.352-8.635-.92.116-.352 8.635.92z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.237 17.537l-.033.1-8.48-.902.033-.1 8.48.902z",
    fill: "#EFEF00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.56 16.292l-.87.92-6.286-4.29.87-.92 6.285 4.29z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.396 16.357l-.666.704-6.162-4.205.666-.704 6.162 4.207z",
    fill: "#EFEF00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15.785 16.126l-.285.302-6.35-4.334.286-.302 6.35 4.334z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.626 16.196l-.08.086-6.237-4.257.08-.086 6.236 4.256z",
    fill: "#EFEF00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M14.834 17.133l-.285.302L8.2 13.1l.285-.3 6.35 4.333z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.675 17.202l-.08.086-6.237-4.257.08-.085 6.237 4.257z",
    fill: "#EFEF00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.54 16.308v-.023c-.01-3.978-3.252-7.196-7.24-7.183-3.986.006-7.214 3.24-7.204 7.218.003 3.978 3.242 7.2 7.228 7.195 3.987 0 7.22-3.228 7.217-7.206zm1.695 0c.004 4.91-3.988 8.897-8.91 8.897-4.92.008-8.92-3.972-8.923-8.882-.012-4.91 3.973-8.903 8.895-8.91 4.922-.017 8.926 3.957 8.938 8.867v.028z",
    fill: "rgba(239, 239, 0, 0.99967)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.057 16.31v-.03c-.01-4.812-3.935-8.705-8.76-8.69-4.823.008-8.73 3.92-8.717 8.733.004 4.813 3.922 8.712 8.746 8.705 4.823 0 8.735-3.906 8.73-8.72zm-.175 0c.004 4.716-3.83 8.543-8.557 8.543-4.727.007-8.567-3.814-8.57-8.53-.012-4.718 3.815-8.552 8.542-8.56 4.727-.014 8.572 3.802 8.584 8.518v.028z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9 16.308v-.024c-.01-4.175-3.415-7.553-7.6-7.54-4.185.007-7.573 3.4-7.563 7.576.003 4.175 3.402 7.558 7.587 7.552 4.184 0 7.578-3.388 7.574-7.564zm-.152 0c.003 4.092-3.322 7.412-7.423 7.412-4.1.006-7.432-3.31-7.435-7.4-.01-4.093 3.31-7.42 7.41-7.426 4.102-.013 7.438 3.297 7.448 7.39v.023z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.92 7.39h1.108v17.892H15.92V7.39z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.05 7.565h.848v17.54h-.848V7.566z",
    fill: "#EFEF00"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15.687 7.27h.363v18.073h-.363V7.27z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15.817 7.43h.103v17.752h-.103V7.43z",
    fill: "#EFEF00"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16.898 7.27h.363v18.073H16.9V7.27z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M17.03 7.43h.102v17.752h-.103V7.43z",
    fill: "#EFEF00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 17.84l.412 1.122-7.89 1.618-.41-1.12 7.89-1.62z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.992 17.987l.315.86L8.57 20.43l-.314-.86 7.736-1.585z",
    fill: "#EFEF00"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15.987 17.593l.135.368-7.97 1.635-.135-.368 7.97-1.634z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M15.965 17.74l.038.103-7.828 1.605-.038-.104 7.828-1.605z",
    fill: "#EFEF00"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.437 18.82l.135.367-7.97 1.634-.135-.367 7.97-1.634z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16.415 18.966l.038.104-7.828 1.605-.038-.104 7.828-1.604z",
    fill: "#EFEF00"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15.603 14.502l.053 1.144-8.273.896-.053-1.144 8.273-.896z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M15.528 14.645l.04.876-8.11.88-.04-.876 8.11-.88z",
    fill: "#EFEF00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M15.647 14.254l.018.375-8.356.905-.02-.375 8.357-.906z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M15.58 14.397l.005.106-8.208.89-.005-.107 8.208-.89z",
    fill: "#EFEF00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M15.706 15.506l.018.375-8.356.907-.018-.375 8.356-.906z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M15.638 15.648l.005.106-8.208.89-.005-.107 8.208-.89z",
    fill: "#EFEF00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M15.806 14.282l-.686 1.063-6.967-3.07.686-1.062 6.966 3.07z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M15.658 14.376l-.525.814-6.83-3.008.525-.814 6.83 3.008z",
    fill: "#EFEF00"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 14.078l-.225.35-7.037-3.1.225-.35 7.038 3.1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M15.855 14.175l-.064.1-6.91-3.045.063-.1 6.912 3.045z",
    fill: "#EFEF00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M15.248 15.24l-.225.35-7.037-3.1.225-.35 7.038 3.1z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M15.105 15.338l-.064.1-6.91-3.045.063-.1 6.912 3.045z",
    fill: "#EFEF00"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M25.35 14.606l-.014 1.143-8.314-.404.015-1.143 8.314.403z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25.268 14.736l-.01.876-8.152-.395.01-.876 8.152.396z",
    fill: "#EFEF00"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M25.41 14.367l-.005.375-8.398-.407.005-.375 8.398.407z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 14.498v.106l-8.25-.4v-.106l8.25.4z",
    fill: "#EFEF00"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M25.393 15.618l-.005.375-8.398-.407.005-.375 8.398.408z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M25.317 15.75v.105l-8.25-.4v-.106l8.25.4z",
    fill: "#EFEF00"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M23.853 11.31l.326 1.023-6.866-.216-.326-1.024 6.865.216z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M23.823 11.426l.25.784-6.73-.212-.25-.784 6.73.212z",
    fill: "#EFEF00"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M23.83 11.093l.107.336-6.934-.22-.107-.335 6.934.218z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M23.806 11.212l.03.095-6.81-.214-.03-.095 6.81.214z",
    fill: "#EFEF00"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M24.186 12.213l.107.336-6.934-.22-.108-.335 6.934.218z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.163 12.332l.03.095-6.81-.214-.03-.095 6.81.214z",
    fill: "#EFEF00"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M24.776 19.403l-.494 1.062-7.653-2.792.493-1.062 7.653 2.793z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.643 19.5l-.38.814-7.502-2.737.38-.814 7.503 2.737z",
    fill: "#EFEF00"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M24.932 19.197l-.162.35-7.73-2.82.162-.35 7.73 2.82z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24.805 19.297l-.046.1-7.594-2.77.046-.1 7.593 2.77z",
    fill: "#EFEF00"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M24.39 20.36l-.16.348-7.73-2.82.16-.35 7.73 2.82z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M24.264 20.46l-.046.098-7.593-2.77.046-.1 7.594 2.77z",
    fill: "#EFEF00"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.155 10.434h10.27v7.543h-10.27v-7.543z",
    fill: "#F6F6FB"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M21.424 17.765c0 2.633-2.3 4.768-5.135 4.768s-5.136-2.135-5.136-4.768 2.3-4.768 5.135-4.768 5.134 2.135 5.134 4.768z",
    fill: "#F6F6FB"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M13.517 12.64h5.546v4.074h-5.546V12.64z",
    fill: "#F6F6FB"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M19.063 17.168c0 1.422-1.24 2.575-2.773 2.575s-2.773-1.153-2.773-2.575c0-1.422 1.242-2.575 2.773-2.575s2.773 1.153 2.773 2.575z",
    fill: "#F6F6FB"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M11.41 10.736h9.758v7.166H11.41v-7.166z",
    fill: "#F00"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M21.167 17.7c0 2.503-2.184 4.53-4.878 4.53s-4.88-2.027-4.88-4.53c0-2.5 2.185-4.53 4.88-4.53s4.877 2.03 4.877 4.53z",
    fill: "#F00"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M13.655 12.833h5.27v3.87h-5.27v-3.87z",
    fill: "#F00"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M18.923 17.134c0 1.35-1.18 2.446-2.634 2.446s-2.635-1.095-2.635-2.446c0-1.35 1.18-2.446 2.634-2.446s2.633 1.095 2.633 2.446z",
    fill: "#F00"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M13.378 13.052H19.2v4.277H13.38V13.05z",
    fill: "#400"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 17.21c0 1.492-1.304 2.702-2.912 2.702s-2.912-1.21-2.912-2.703c0-1.494 1.304-2.704 2.912-2.704s2.912 1.21 2.912 2.703z",
    fill: "#400"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M14.717 14.304h3.145v2.31h-3.145v-2.31z",
    fill: "#400"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M17.86 16.87c0 .807-.703 1.46-1.57 1.46s-1.573-.653-1.573-1.46c0-.805.704-1.46 1.572-1.46s1.57.655 1.57 1.46z",
    fill: "#400"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M13.66 13.386h5.257v3.86h-5.255v-3.86z",
    fill: "#FFF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M18.916 17.138c0 1.348-1.176 2.44-2.628 2.44s-2.628-1.092-2.628-2.44c0-1.348 1.176-2.44 2.628-2.44s2.628 1.092 2.628 2.44z",
    fill: "#FFF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M14.87 14.516h2.838V16.6H14.87v-2.084z",
    fill: "#FFF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M17.708 16.833c0 .728-.635 1.317-1.42 1.317s-1.418-.59-1.418-1.317c0-.728.635-1.317 1.42-1.317s1.418.59 1.418 1.317z",
    fill: "#FFF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M15.56 17.513h1.54v1.13h-1.54v-1.13z",
    fill: "#3B3BFF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 18.613c0 .395-.345.715-.77.715s-.77-.32-.77-.715c0-.395.345-.715.77-.715s.77.32.77.715z",
    fill: "#3B3BFF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M15.914 17.844h.832v.61h-.832v-.61z",
    fill: "#3B3BFF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M16.746 18.523c0 .213-.186.386-.416.386s-.416-.174-.416-.387c0-.213.186-.386.416-.386s.416.173.416.386z",
    fill: "#3B3BFF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M15.598 17.558h1.464v1.075H15.6v-1.075z",
    fill: "#3B3BFF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 18.603c0 .375-.327.68-.73.68s-.733-.305-.733-.68c0-.375.328-.68.732-.68s.73.305.73.68z",
    fill: "#3B3BFF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M15.934 17.873h.79v.58h-.79v-.58z",
    fill: "#3B3BFF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M16.725 18.518c0 .203-.177.367-.395.367s-.395-.164-.395-.367c0-.203.177-.367.395-.367s.395.165.395.368z",
    fill: "#3B3BFF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M15.893 17.906h.873v.642h-.873v-.642z",
    fill: "#3B3BFF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M16.766 18.53c0 .223-.196.404-.437.404s-.438-.182-.438-.405c0-.225.196-.406.437-.406s.436.182.436.405z",
    fill: "#3B3BFF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M16.094 18.094h.472v.346h-.472v-.346z",
    fill: "#3B3BFF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M16.565 18.48c0 .12-.106.218-.236.218s-.237-.098-.237-.22c0-.12.106-.218.236-.218s.235.098.235.22z",
    fill: "#3B3BFF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M15.935 17.956h.788v.58h-.788v-.58z",
    fill: "#3B3BFF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M16.724 18.52c0 .2-.176.365-.394.365s-.394-.164-.394-.366c0-.203.176-.367.394-.367s.394.164.394.366z",
    fill: "#3B3BFF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M16.117 18.125h.426v.313h-.426v-.313z",
    fill: "#3B3BFF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16.542 18.473c0 .11-.095.198-.213.198s-.214-.087-.214-.197c0-.11.095-.198.213-.198s.212.088.212.198z",
    fill: "#3B3BFF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M16.097 17.833c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM16.96 17.833c0 .127-.102.23-.23.23s-.23-.103-.23-.23.104-.23.23-.23.23.103.23.23zM16.52 18.317c0 .127-.102.23-.23.23s-.23-.103-.23-.23.104-.23.23-.23.23.103.23.23zM16.13 18.786c0 .127-.102.23-.23.23s-.23-.103-.23-.23.104-.23.23-.23.23.103.23.23zM16.95 18.802c0 .127-.102.23-.23.23s-.23-.103-.23-.23.104-.23.23-.23.23.103.23.23z",
    fill: "#FFF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M11.565 11.79h1.953v.145h-1.953v-.146zm.17-.404v.407h1.66v-.407h-1.66zm-.147 1.337h1.953v.146H11.59v-.147zm1.436-.04v-.006c0-.265-.205-.48-.457-.48s-.456.215-.456.48zm-.964.02c0-.294.227-.533.507-.533s.507.238.508.533v.007zm-.326-.728v.73h1.66v-.73h-1.66zm-.17-.73h1.953v.14h-1.953v-.14zm0-.194v.197h.15v-.196h-.15zm1.804 0v.197h.15v-.196h-.15zm-1.504.005v.196h.15v-.195h-.15zm1.196-.004v.197h.15v-.196h-.15zm-.904-.184v.196h.15v-.196h-.15zm.6 0v.196h.15v-.196h-.15zm-.292-.004v.196h.15v-.196h-.15zm-.308.202v.188h.75v-.188h-.75z",
    fill: "#FF0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 11.358h.15v.196h-.15v-.196zM12.824 11.354h.15v.196h-.15v-.196z",
    fill: "#F00"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M19.06 11.812h1.954v.146H19.06v-.146zm.17-.403v.406h1.66v-.407h-1.66zm-.146 1.336h1.953v.146h-1.953v-.146zm1.436-.04V12.7c0-.265-.205-.48-.457-.48s-.456.215-.456.48zm-.964.022c0-.295.227-.534.507-.534s.507.238.508.533v.007zm-.326-.73v.732h1.66V12h-1.66zm-.17-.728h1.954v.138H19.06v-.138zm0-.195v.196h.15v-.195h-.15zm1.804 0v.196h.15v-.195h-.15zm-1.504.004v.195h.15v-.196h-.15zm1.196-.005v.196h.15v-.195h-.15zm-.904-.185v.196h.15v-.196h-.15zm.6 0v.196h.15v-.196h-.15zm-.292-.004v.196h.15v-.196h-.15zm-.308.2v.19h.75v-.19h-.75z",
    fill: "#FF0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M19.645 11.38h.15v.197h-.15v-.196zM20.32 11.377h.15v.196h-.15v-.196z",
    fill: "#F00"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M15.383 11.812h1.953v.146h-1.953v-.146zm.17-.403v.406h1.66v-.407h-1.66zm-.147 1.336h1.953v.146h-1.954v-.146zm1.436-.04V12.7c0-.265-.205-.48-.457-.48s-.456.215-.456.48zm-.963.022c0-.295.226-.534.506-.534s.507.238.508.533v.007zm-.327-.73v.732h1.66V12h-1.66zm-.17-.728h1.953v.138h-1.953v-.138zm0-.195v.196h.15v-.195h-.15zm1.803 0v.196h.15v-.195h-.15zm-1.503.004v.195h.15v-.196h-.15zm1.195-.005v.196h.15v-.195h-.15zm-.903-.185v.196h.15v-.196h-.15zm.6 0v.196h.15v-.196h-.15zm-.292-.004v.196h.15v-.196h-.15zm-.31.2v.19h.75v-.19h-.75z",
    fill: "#FF0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M15.968 11.38h.15v.197h-.15v-.196zM16.642 11.377h.15v.196h-.15v-.196z",
    fill: "#F00"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 16.37h1.954v.146H11.4v-.146zm.17-.403v.407h1.66v-.407h-1.66zm-.146 1.337h1.953v.146h-1.953v-.146zm1.436-.04v-.006c0-.265-.205-.48-.457-.48s-.456.215-.456.48zm-.964.02c0-.294.227-.533.507-.533s.507.24.508.534v.007zm-.326-.728v.73h1.66v-.73h-1.66zm-.17-.73h1.953v.14H11.4v-.14zm0-.194v.196h.15v-.196h-.15zm1.804 0v.196h.15v-.196h-.15zm-1.504.004v.196h.15v-.196h-.15zm1.196-.004v.196h.15v-.196h-.15zm-.904-.185v.196h.15v-.196h-.15zm.6 0v.196h.15v-.196h-.15zm-.292-.004v.196h.15v-.197h-.15zm-.308.202v.188h.75v-.188h-.75z",
    fill: "#FF0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M11.986 15.94h.15v.195h-.15v-.196zM12.66 15.935h.15v.196h-.15v-.195z",
    fill: "#F00"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M19.202 16.323h1.953v.146h-1.953v-.147zm.17-.403v.407h1.66v-.407h-1.66zm-.147 1.338h1.953v.146h-1.953v-.146zm1.436-.04v-.006c0-.265-.204-.48-.456-.48s-.456.215-.456.48zm-.963.02c0-.294.227-.533.507-.533s.507.238.508.533v.007zm-.326-.728v.73h1.66v-.73h-1.66zm-.17-.73h1.954v.14H19.2v-.14zm0-.194v.196h.15v-.196h-.15zm1.805 0v.196h.15v-.196h-.15zm-1.504.004v.196h.15v-.196h-.15zm1.197-.004v.196h.15v-.196h-.15zm-.904-.185v.197h.15V15.4h-.15zm.6 0v.197h.15V15.4h-.15zm-.292-.003v.196h.15v-.196h-.15zm-.307.202v.187h.75V15.6h-.75z",
    fill: "#FF0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M19.786 15.892h.15v.196h-.15v-.196zM20.46 15.888h.15v.196h-.15v-.196z",
    fill: "#F00"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M13.09 20.79l1.276-1.476.11.095-1.274 1.475-.11-.095zm-.195-.392l.31.266 1.083-1.255-.31-.267-1.083 1.255zm.92.984l1.275-1.476.11.095-1.274 1.477-.11-.095zm.907-1.112c-.002 0-.003-.003-.005-.004-.202-.173-.498-.16-.663.032s-.134.485.067.66zm-.613.742c-.225-.192-.258-.52-.076-.732s.512-.228.736-.036l.005.004zm-.767-.23l.555.478 1.084-1.255-.555-.477-1.084 1.255zm-.664-.347l1.274-1.476.105.09-1.276 1.475-.105-.09zm-.15-.127l.15.128.098-.114-.15-.128-.097.114zm1.178-1.363l.15.128.097-.114-.15-.13-.097.115zm-.978 1.14l.15.127.097-.114-.15-.128-.097.114zm.777-.907l.15.128.097-.114-.15-.128-.097.114zm-.73.562l.15.128.097-.114-.15-.128-.097.114zm.39-.453l.15.128.098-.114-.15-.127-.097.114zm-.192.218l.15.128.097-.114-.15-.13-.097.115zm-.048.364l.143.122.49-.567-.144-.123-.49.567z",
    fill: "#FF0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M13.145 20.066l.098-.114.15.128-.1.114-.148-.128zM13.583 19.554l.098-.114.15.128-.098.114-.15-.128z",
    fill: "#F00"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M19.56 20.766l-1.275-1.476-.11.095 1.274 1.476.11-.094zm.196-.39l-.31.265-1.083-1.254.31-.266 1.083 1.255zm-.92.983l-1.275-1.477-.11.095 1.275 1.476.11-.095zm-.907-1.113l.004-.004c.202-.173.498-.16.663.032s.134.485-.067.66zm.612.742c.224-.193.257-.52.075-.733s-.512-.228-.736-.036c0 .003-.002.004-.004.005zm.766-.23l-.555.477-1.084-1.255.554-.477 1.084 1.255zm.664-.348l-1.275-1.476-.105.09 1.275 1.476.105-.09zm.148-.127l-.15.128-.097-.114.15-.13.097.115zm-1.177-1.363l-.15.128-.097-.114.15-.128.097.114zm.978 1.14l-.148.127-.098-.115.15-.128.097.114zm-.776-.907l-.15.128-.097-.114.15-.13.097.115zm.73.562l-.15.128-.097-.114.15-.127.097.114zm-.39-.454l-.15.128-.098-.113.15-.128.097.113zm.192.22l-.15.127-.097-.114.148-.128.098.114zm.048.363l-.143.123-.488-.568.143-.123.49.566z",
    fill: "#FF0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M19.505 20.043l-.098-.114-.15.127.1.114.148-.127zM19.068 19.53l-.098-.114-.15.128.1.114.148-.128z",
    fill: "#F00"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M15.535 13.494h1.54v1.132h-1.54v-1.13z",
    fill: "#3B3BFF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M17.075 14.594c0 .395-.345.715-.77.715s-.77-.32-.77-.716c0-.395.345-.715.77-.715s.77.32.77.714z",
    fill: "#3B3BFF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M15.89 13.825h.83v.61h-.83v-.61z",
    fill: "#3B3BFF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M16.72 14.504c0 .213-.185.386-.415.386s-.416-.173-.416-.386c0-.213.185-.386.415-.386s.416.173.416.386z",
    fill: "#3B3BFF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M15.573 13.54h1.464v1.074h-1.463V13.54z",
    fill: "#3B3BFF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M17.036 14.584c0 .375-.328.68-.732.68s-.732-.305-.732-.68c0-.375.328-.68.732-.68s.732.305.732.68z",
    fill: "#3B3BFF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M15.91 13.854h.79v.58h-.79v-.58z",
    fill: "#3B3BFF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 14.5c0 .202-.177.366-.395.366s-.395-.164-.395-.367c0-.204.177-.368.395-.368s.395.164.395.367z",
    fill: "#3B3BFF"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 13.887h.873v.642h-.872v-.643z",
    fill: "#3B3BFF"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16.742 14.51c0 .224-.196.405-.437.405s-.437-.182-.437-.405c0-.224.196-.405.437-.405s.437.182.437.405z",
    fill: "#3B3BFF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M16.07 14.075h.47v.346h-.47v-.345z",
    fill: "#3B3BFF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M16.54 14.46c0 .12-.105.22-.235.22s-.236-.1-.236-.22.105-.22.235-.22.236.1.236.22z",
    fill: "#3B3BFF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M15.91 13.937h.79v.58h-.79v-.58z",
    fill: "#3B3BFF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 14.5c0 .202-.177.366-.395.366s-.394-.164-.394-.366c0-.202.177-.366.395-.366s.394.164.394.366z",
    fill: "#3B3BFF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M16.092 14.106h.426v.313h-.426v-.314z",
    fill: "#3B3BFF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M16.518 14.454c0 .11-.095.198-.213.198s-.213-.088-.213-.198c0-.11.095-.198.213-.198s.213.088.213.198z",
    fill: "#3B3BFF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M16.072 13.814c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM16.936 13.814c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM16.497 14.298c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM16.106 14.767c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM16.927 14.782c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23z",
    fill: "#FFF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M15.535 15.49h1.54v1.132h-1.54v-1.13z",
    fill: "#3B3BFF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M17.075 16.59c0 .396-.345.716-.77.716s-.77-.32-.77-.715c0-.394.345-.714.77-.714s.77.32.77.715z",
    fill: "#3B3BFF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15.89 15.822h.83v.61h-.83v-.61z",
    fill: "#3B3BFF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M16.72 16.502c0 .213-.185.386-.415.386s-.416-.173-.416-.386c0-.213.185-.386.415-.386s.416.173.416.386z",
    fill: "#3B3BFF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M15.573 15.537h1.464v1.075h-1.463v-1.075z",
    fill: "#3B3BFF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M17.036 16.58c0 .376-.328.68-.732.68s-.732-.304-.732-.68c0-.374.328-.678.732-.678s.732.304.732.68z",
    fill: "#3B3BFF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M15.91 15.85h.79v.58h-.79v-.58z",
    fill: "#3B3BFF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 16.496c0 .203-.177.367-.395.367s-.395-.164-.395-.367c0-.203.177-.367.395-.367s.395.163.395.366z",
    fill: "#3B3BFF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 15.884h.873v.642h-.872v-.642z",
    fill: "#3B3BFF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M16.742 16.508c0 .224-.196.405-.437.405s-.437-.182-.437-.405c0-.224.196-.405.437-.405s.437.182.437.405z",
    fill: "#3B3BFF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M16.07 16.072h.47v.346h-.47v-.346z",
    fill: "#3B3BFF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M16.54 16.457c0 .12-.105.22-.235.22s-.236-.1-.236-.22.105-.22.235-.22.236.1.236.22z",
    fill: "#3B3BFF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M15.91 15.934h.79v.58h-.79v-.58z",
    fill: "#3B3BFF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 16.497c0 .202-.177.366-.395.366s-.394-.164-.394-.366c0-.202.177-.366.395-.366s.394.165.394.367z",
    fill: "#3B3BFF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M16.092 16.104h.426v.313h-.426v-.313z",
    fill: "#3B3BFF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M16.518 16.45c0 .11-.095.2-.213.2s-.213-.09-.213-.2c0-.108.095-.197.213-.197s.213.088.213.198z",
    fill: "#3B3BFF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16.072 15.812c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM16.936 15.812c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM16.497 16.296c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM16.106 16.765c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM16.927 16.78c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23z",
    fill: "#FFF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M17.244 15.49h1.54v1.132h-1.54v-1.13z",
    fill: "#3B3BFF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M18.784 16.59c0 .396-.345.716-.77.716s-.77-.32-.77-.715c0-.394.345-.714.77-.714s.77.32.77.715z",
    fill: "#3B3BFF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M17.598 15.822h.832v.61h-.832v-.61z",
    fill: "#3B3BFF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M18.43 16.502c0 .213-.186.386-.416.386s-.416-.173-.416-.386c0-.213.186-.386.416-.386s.416.173.416.386z",
    fill: "#3B3BFF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M17.282 15.537h1.463v1.075h-1.463v-1.075z",
    fill: "#3B3BFF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M18.745 16.58c0 .376-.328.68-.732.68s-.732-.304-.732-.68c0-.374.33-.678.733-.678s.732.304.732.68z",
    fill: "#3B3BFF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M17.62 15.85h.79v.58h-.79v-.58z",
    fill: "#3B3BFF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M18.41 16.496c0 .203-.178.367-.396.367s-.395-.164-.395-.367c0-.203.176-.367.394-.367s.395.163.395.366z",
    fill: "#3B3BFF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M17.577 15.884h.873v.642h-.873v-.642z",
    fill: "#3B3BFF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M18.45 16.508c0 .224-.196.405-.437.405s-.437-.182-.437-.405c0-.224.196-.405.437-.405s.437.182.437.405z",
    fill: "#3B3BFF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M17.778 16.072h.472v.346h-.472v-.346z",
    fill: "#3B3BFF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 16.457c0 .12-.106.22-.236.22s-.236-.1-.236-.22.106-.22.236-.22.236.1.236.22z",
    fill: "#3B3BFF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M17.62 15.934h.787v.58h-.788v-.58z",
    fill: "#3B3BFF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M18.408 16.497c0 .202-.176.366-.394.366s-.394-.164-.394-.366c0-.202.176-.366.394-.366s.394.165.394.367z",
    fill: "#3B3BFF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 16.104h.427v.313H17.8v-.313z",
    fill: "#3B3BFF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M18.227 16.45c0 .11-.095.2-.213.2s-.213-.09-.213-.2c0-.108.096-.197.214-.197s.213.088.213.198z",
    fill: "#3B3BFF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M17.78 15.812c0 .127-.102.23-.23.23s-.23-.103-.23-.23.104-.23.23-.23.23.103.23.23zM18.645 15.812c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM18.205 16.296c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM17.815 16.765c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM18.636 16.78c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23z",
    fill: "#FFF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M13.826 15.49h1.54v1.132h-1.54v-1.13z",
    fill: "#3B3BFF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M15.366 16.59c0 .396-.345.716-.77.716s-.77-.32-.77-.715c0-.394.345-.714.77-.714s.77.32.77.715z",
    fill: "#3B3BFF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M14.18 15.822h.832v.61h-.832v-.61z",
    fill: "#3B3BFF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M15.012 16.502c0 .213-.186.386-.416.386s-.416-.173-.416-.386c0-.213.186-.386.416-.386s.416.173.416.386z",
    fill: "#3B3BFF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M13.864 15.537h1.463v1.075h-1.463v-1.075z",
    fill: "#3B3BFF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M15.328 16.58c0 .376-.328.68-.732.68s-.732-.304-.732-.68c0-.374.328-.678.732-.678s.732.304.732.68z",
    fill: "#3B3BFF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 15.85h.79v.58h-.79v-.58z",
    fill: "#3B3BFF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M14.99 16.496c0 .203-.176.367-.394.367s-.395-.164-.395-.367c0-.203.178-.367.396-.367s.395.163.395.366z",
    fill: "#3B3BFF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M14.16 15.884h.872v.642h-.873v-.642z",
    fill: "#3B3BFF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M15.033 16.508c0 .224-.196.405-.437.405s-.437-.182-.437-.405c0-.224.195-.405.436-.405s.437.182.437.405z",
    fill: "#3B3BFF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M14.36 16.072h.472v.346h-.472v-.346z",
    fill: "#3B3BFF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M14.832 16.457c0 .12-.106.22-.236.22s-.236-.1-.236-.22.106-.22.236-.22.236.1.236.22z",
    fill: "#3B3BFF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M14.202 15.934h.788v.58h-.788v-.58z",
    fill: "#3B3BFF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M14.99 16.497c0 .202-.176.366-.394.366s-.394-.164-.394-.366c0-.202.176-.366.394-.366s.394.165.394.367z",
    fill: "#3B3BFF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M14.383 16.104h.426v.313h-.427v-.313z",
    fill: "#3B3BFF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M14.81 16.45c0 .11-.096.2-.214.2s-.213-.09-.213-.2c0-.108.095-.197.213-.197s.213.088.213.198z",
    fill: "#3B3BFF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M14.364 15.812c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM15.227 15.812c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM14.788 16.296c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM14.397 16.765c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23zM15.218 16.78c0 .127-.103.23-.23.23s-.23-.103-.23-.23.103-.23.23-.23.23.103.23.23z",
    fill: "#FFF"
  })));
};
export default SvgPt;